var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      class: _vm.$vuetify.breakpoint.xs ? "ma-1" : "ma-5",
      attrs: { flat: "", loading: _vm.loading },
    },
    [
      _c(
        "v-card-title",
        { staticClass: "pb-0 d-flex align-center" },
        [
          _c("span", [_vm._v(_vm._s(_vm.$t("twilio-overview-title")))]),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function ($event) {
                  return _vm.$emit("go-to-detail")
                },
              },
            },
            [_c("v-icon", [_vm._v("mdi-arrow-right")])],
            1
          ),
        ],
        1
      ),
      _vm.organizationsSummary.length > 0
        ? _c("div", { staticClass: "health-summary px-4 pb-2" }, [
            _c(
              "span",
              { staticClass: "health-chip health-chip-ok" },
              [
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-1",
                    attrs: { "x-small": "", color: "green" },
                  },
                  [_vm._v("mdi-check-circle")]
                ),
                _vm._v(
                  " " +
                    _vm._s(_vm.healthCounts.ok) +
                    " (" +
                    _vm._s(_vm.healthCounts.okPct) +
                    "%) "
                ),
              ],
              1
            ),
            _c(
              "span",
              { staticClass: "health-chip health-chip-warning" },
              [
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-1",
                    attrs: { "x-small": "", color: "amber" },
                  },
                  [_vm._v("mdi-alert-outline")]
                ),
                _vm._v(
                  " " +
                    _vm._s(_vm.healthCounts.warning) +
                    " (" +
                    _vm._s(_vm.healthCounts.warningPct) +
                    "%) "
                ),
              ],
              1
            ),
            _c(
              "span",
              { staticClass: "health-chip health-chip-error" },
              [
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-1",
                    attrs: { "x-small": "", color: "red" },
                  },
                  [_vm._v("mdi-alert-circle")]
                ),
                _vm._v(
                  " " +
                    _vm._s(_vm.healthCounts.critical) +
                    " (" +
                    _vm._s(_vm.healthCounts.criticalPct) +
                    "%) "
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c("v-divider"),
      _vm.errorMessage
        ? _c(
            "v-alert",
            {
              staticClass: "ma-4",
              attrs: { type: "error", dense: "", text: "" },
            },
            [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]
          )
        : _vm._e(),
      !_vm.errorMessage
        ? _c(
            "v-card-text",
            {
              class: _vm.$vuetify.breakpoint.xs ? "pa-0" : "pa-0",
              style: _vm.overviewContentStyle,
            },
            [
              _vm.$vuetify.breakpoint.xs
                ? [
                    _c("table", { staticClass: "mobile-table" }, [
                      _c("thead", { staticClass: "sticky-header" }, [
                        _c(
                          "tr",
                          [
                            _c("th", { staticClass: "mobile-th-org" }, [
                              _vm._v(" Org "),
                            ]),
                            _vm._l(_vm.timeRanges, function (range, idx) {
                              return _c(
                                "th",
                                {
                                  key: range.key,
                                  staticClass: "mobile-th-range",
                                  style:
                                    idx % 2 === 0
                                      ? "background-color: #f0f0f0"
                                      : "",
                                  on: {
                                    click: function ($event) {
                                      return _vm.setSortRange(range.key)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(range.label.replace("Last ", "")) +
                                      " "
                                  ),
                                  _vm.sortRange === range.key
                                    ? _c(
                                        "v-icon",
                                        { attrs: { "x-small": "" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.sortDirection === "desc"
                                                ? "mdi-arrow-down"
                                                : "mdi-arrow-up"
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                          ],
                          2
                        ),
                      ]),
                      _c(
                        "tbody",
                        _vm._l(_vm.sortedOrganizations, function (org, idx) {
                          return _c(
                            "tr",
                            {
                              key: org.id,
                              staticClass: "mobile-tr",
                              class: {
                                "mobile-tr-critical":
                                  _vm.getOrgSeverity(org) === "critical",
                                "mobile-tr-even": idx % 2 === 1,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.selectOrganization(org.id)
                                },
                              },
                            },
                            [
                              _c("td", { staticClass: "mobile-td-org" }, [
                                _c(
                                  "div",
                                  { staticClass: "mobile-org-inner" },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-1 flex-shrink-0",
                                        attrs: {
                                          color: _vm.getOrgHealthColor(org),
                                          "x-small": "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.getOrgHealthIcon(org))
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "mobile-org-name" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.organizationName(
                                              org.displayName
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._l(
                                _vm.timeRanges,
                                function (range, rangeIdx) {
                                  return _c(
                                    "td",
                                    {
                                      key: range.key,
                                      staticClass: "mobile-td-range",
                                      class: {
                                        "col-striped": rangeIdx % 2 === 0,
                                      },
                                    },
                                    [
                                      _vm.getTotalByRange(org, range.key) > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "vertical-bars vertical-bars-mobile",
                                            },
                                            [
                                              _vm.getCountByType(
                                                org,
                                                range.key,
                                                "critical"
                                              ) > 0
                                                ? _c(
                                                    "div",
                                                    { staticClass: "vbar-row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "vbar vbar-critical",
                                                          style: {
                                                            width:
                                                              _vm.getBarWidthPercent(
                                                                org,
                                                                range.key,
                                                                "critical"
                                                              ) + "%",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "vbar-label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getCountByType(
                                                                    org,
                                                                    range.key,
                                                                    "critical"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.getCountByType(
                                                org,
                                                range.key,
                                                "error"
                                              ) > 0
                                                ? _c(
                                                    "div",
                                                    { staticClass: "vbar-row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "vbar vbar-error",
                                                          style: {
                                                            width:
                                                              _vm.getBarWidthPercent(
                                                                org,
                                                                range.key,
                                                                "error"
                                                              ) + "%",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "vbar-label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getCountByType(
                                                                    org,
                                                                    range.key,
                                                                    "error"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.getCountByType(
                                                org,
                                                range.key,
                                                "warning"
                                              ) > 0
                                                ? _c(
                                                    "div",
                                                    { staticClass: "vbar-row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "vbar vbar-warning",
                                                          style: {
                                                            width:
                                                              _vm.getBarWidthPercent(
                                                                org,
                                                                range.key,
                                                                "warning"
                                                              ) + "%",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "vbar-label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getCountByType(
                                                                    org,
                                                                    range.key,
                                                                    "warning"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            {
                                              staticClass: "grey--text",
                                              staticStyle: {
                                                "font-size": "10px",
                                              },
                                            },
                                            [_vm._v("—")]
                                          ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        }),
                        0
                      ),
                    ]),
                  ]
                : _vm._e(),
              !_vm.$vuetify.breakpoint.xs
                ? _c("v-simple-table", {
                    attrs: { dense: "", "fixed-header": "", height: "60vh" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function () {
                            return [
                              _c("thead", [
                                _c(
                                  "tr",
                                  [
                                    _c("th", [_vm._v("Organization")]),
                                    _vm._l(
                                      _vm.timeRanges,
                                      function (range, idx) {
                                        return _c(
                                          "th",
                                          {
                                            key: range.key,
                                            staticClass:
                                              "text-center sortable-header",
                                            class: {
                                              "col-striped": idx % 2 === 0,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setSortRange(
                                                  range.key
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(range.label) + " "
                                            ),
                                            _vm.sortRange === range.key
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "ml-1",
                                                    attrs: { "x-small": "" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.sortDirection ===
                                                          "desc"
                                                          ? "mdi-arrow-down"
                                                          : "mdi-arrow-up"
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    _c("th", {
                                      staticStyle: { width: "32px" },
                                    }),
                                  ],
                                  2
                                ),
                              ]),
                              _c(
                                "tbody",
                                _vm._l(
                                  _vm.sortedOrganizations,
                                  function (org, idx) {
                                    return _c(
                                      "tr",
                                      {
                                        key: org.id,
                                        staticClass: "org-row",
                                        class: {
                                          "org-row-critical":
                                            _vm.getOrgSeverity(org) ===
                                            "critical",
                                          "org-row-even": idx % 2 === 1,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectOrganization(
                                              org.id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("td", [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-center",
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-2",
                                                  attrs: {
                                                    color:
                                                      _vm.getOrgHealthColor(
                                                        org
                                                      ),
                                                    small: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getOrgHealthIcon(
                                                          org
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "font-weight-medium",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.organizationName(
                                                          org.displayName
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]),
                                        _vm._l(
                                          _vm.timeRanges,
                                          function (range, rangeIdx) {
                                            return _c(
                                              "td",
                                              {
                                                key: range.key,
                                                staticClass: "text-center",
                                                class: {
                                                  "col-striped":
                                                    rangeIdx % 2 === 0,
                                                },
                                              },
                                              [
                                                _vm.getTotalByRange(
                                                  org,
                                                  range.key
                                                ) > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "vertical-bars vertical-bars-desktop",
                                                      },
                                                      [
                                                        _vm.getCountByType(
                                                          org,
                                                          range.key,
                                                          "critical"
                                                        ) > 0
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "vbar-row",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "vbar vbar-critical",
                                                                    style: {
                                                                      width:
                                                                        _vm.getBarWidthPercent(
                                                                          org,
                                                                          range.key,
                                                                          "critical"
                                                                        ) + "%",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "vbar-label",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.getCountByType(
                                                                              org,
                                                                              range.key,
                                                                              "critical"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm.getCountByType(
                                                          org,
                                                          range.key,
                                                          "error"
                                                        ) > 0
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "vbar-row",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "vbar vbar-error",
                                                                    style: {
                                                                      width:
                                                                        _vm.getBarWidthPercent(
                                                                          org,
                                                                          range.key,
                                                                          "error"
                                                                        ) + "%",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "vbar-label",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.getCountByType(
                                                                              org,
                                                                              range.key,
                                                                              "error"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm.getCountByType(
                                                          org,
                                                          range.key,
                                                          "warning"
                                                        ) > 0
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "vbar-row",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "vbar vbar-warning",
                                                                    style: {
                                                                      width:
                                                                        _vm.getBarWidthPercent(
                                                                          org,
                                                                          range.key,
                                                                          "warning"
                                                                        ) + "%",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "vbar-label",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.getCountByType(
                                                                              org,
                                                                              range.key,
                                                                              "warning"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "grey--text text-caption",
                                                      },
                                                      [_vm._v("—")]
                                                    ),
                                              ]
                                            )
                                          }
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-center",
                                            staticStyle: {
                                              width: "32px",
                                              padding: "0",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { small: "" } },
                                              [_vm._v("mdi-chevron-right")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      2
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      857501568
                    ),
                  })
                : _vm._e(),
              !_vm.organizationsSummary || _vm.organizationsSummary.length === 0
                ? _c(
                    "div",
                    { staticClass: "text-body-2 grey--text text-center py-6" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("twilio-overview-no-organizations")) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }